module.exports = __webpack_public_path__ + "static/img/teaser_02.ec861dde.png";